import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { css } from "@emotion/react";

const decodeEntities = (function () {
  const decodeHTMLEntities = (str) => {
    if (str && typeof str === "string") {
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
    }
    return str;
  };

  return decodeHTMLEntities;
})();

const createMarkup = (props) => {
  const shortText =
    decodeEntities(
      props.event.description
        .replace(/<(?:.|\n)*?>/gm, "")
        .split(" ")
        .slice(0, 80)
        .join(" "),
    ).trim() + "...";
  return { __html: shortText };
};

const EventCard = (props) => {
  return (
    <div className="col-md-4 col-12">
      <div className="my-3">
        {props.image && (
          <GatsbyImage
            image={getImage(props.image)}
            alt={props.event.name}
            className="img-fluid rounded"
          />
        )}
        <div>
          <h3 className="my-3">{props.event.name}</h3>
          <h4 className=" mb-2" style={{ color: `#c63f17` }}>
            {props.event.date}
          </h4>
          <div className="event-body">
            <p
              css={{
                letterSpacing: "0.05rem",
                lineHeight: "1.5rem",
                whiteSpace: "pre-line",
              }}
              dangerouslySetInnerHTML={createMarkup(props)}
            ></p>
          </div>
          <Link
            to={props.event.slug}
            css={css`
              text-decoration: none;
              color: #422e40;
            `}
          >
            Részletek
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
